import Hero from '@/components/Hero/Hero';
import RawHtml from '@/components/RawHtml/RawHtml';
import { useAppContext } from '@/contexts/AppContext';
import { Link } from '@tanstack/react-router';
import { type FC } from 'react';

const ApplicationRequirementsPage: FC = () => {
  const { community } = useAppContext();

  return (
    <div>
      <Hero
        title="Application Requirements"
        subtitle="Everything you need to know to join our community"
        showCTA
      />
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-lg mx-auto">
            <p className="lead text-xl text-gray-600 mb-8">
              We are excited that you are interested in making our community your new home! To
              ensure a smooth application process, please review our rental requirements below.
            </p>

            {community.applicationRequirements ? (
              <RawHtml html={community.applicationRequirements} />
            ) : null}

            <div className="bg-primary-50 p-8 rounded-xl text-center">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Ready to Apply?</h3>
              <p className="text-gray-600 mb-6">
                If you meet our requirements and are ready to find your perfect home, schedule a
                tour or contact us today!
              </p>
              <div className="flex justify-center gap-4">
                <Link to="/floor-plans" className="btn-primary">
                  View Floor Plans
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ApplicationRequirementsPage;
